let REGEX = /{*}/i;

export const parsePortletConfig = (config) => {
    config && Object.keys(config).forEach(key => {
        const value = config[key];
        // Portlet properties only allow strings as values. If objects are stored as stringified values, they are parsed here.
        if (REGEX.test(value)) {
            try {
                config[key] = JSON.parse(value);
            } catch (e) {
                console.warn(`Failed to parse config property ${key}: `, value);
            }
        }
    });
    return config;
};



// WEBPACK FOOTER //
// ./js/utils/portlet-config-util.js